export default "__VITE_ASSET__FdIWL3u$__"